var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.record.company.classification[_vm.classification] &&
    _vm.record.company.classification[_vm.classification].enabled &&
    _vm.record.classification[_vm.classification]
  )?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-select',{attrs:{"value":_vm.record.classification[_vm.classification],"type":"text","disabled":"","plain":"","options":_vm.classificationOptions[_vm.classification]}})],1)],1)],1):(
    _vm.classificationGroup &&
    _vm.classificationGroup.enabled &&
    _vm.record.classification[_vm.classification]
  )?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-select',{attrs:{"value":_vm.record.classification[_vm.classification],"type":"text","disabled":"","plain":"","options":_vm.classificationGroup.options.map(function (option) {
            return { value: option._id, text: option.value };
          })}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }